import { useFocusRing as $f7dceffc5ad7768b$export$4e328f61c538687f } from "../../../../../@react-aria/focus/dist/useFocusRing.js";
import { useHover as $6179b936705e76d3$export$ae780daf29e6d456 } from "../../../../../@react-aria/interactions/dist/useHover.js";
import React__default, { createContext, useReducer, createRef, useRef, useCallback, useMemo, useId, useState, useEffect, useContext, Fragment } from "react";
import { flushSync } from "react-dom";
import { useActivePress as w } from "../../hooks/use-active-press.js";
import { useByComparator as u } from "../../hooks/use-by-comparator.js";
import { useControllable as T } from "../../hooks/use-controllable.js";
import { useDefaultValue as l } from "../../hooks/use-default-value.js";
import { useDidElementMove as s } from "../../hooks/use-did-element-move.js";
import { useDisposables as p } from "../../hooks/use-disposables.js";
import { useElementSize as d } from "../../hooks/use-element-size.js";
import { useEvent as o } from "../../hooks/use-event.js";
import { useInertOthers as y$1 } from "../../hooks/use-inert-others.js";
import { useIsoMorphicEffect as n } from "../../hooks/use-iso-morphic-effect.js";
import { useLatestValue as s$2 } from "../../hooks/use-latest-value.js";
import { useOnDisappear as m } from "../../hooks/use-on-disappear.js";
import { useOutsideClick as R } from "../../hooks/use-outside-click.js";
import { useOwnerDocument as n$1 } from "../../hooks/use-owner.js";
import { useResolveButtonType as e } from "../../hooks/use-resolve-button-type.js";
import { useScrollLock as f } from "../../hooks/use-scroll-lock.js";
import { useSyncRefs as y } from "../../hooks/use-sync-refs.js";
import { useTextValue as s$1 } from "../../hooks/use-text-value.js";
import { useTrackedPointer as u$5 } from "../../hooks/use-tracked-pointer.js";
import { useTransition as R$1, transitionDataAttributes as H$1 } from "../../hooks/use-transition.js";
import { useDisabled as a } from "../../internal/disabled.js";
import { FloatingProvider as ve, useFloatingReference as ye, useFloatingReferenceProps as Fe, useResolvedAnchor as xe, useFloatingPanel as Re, useFloatingPanelProps as be$1 } from "../../internal/floating.js";
import { FormFields as j } from "../../internal/form-fields.js";
import { useFrozenData as l$1 } from "../../internal/frozen.js";
import { useProvidedId as u$2 } from "../../internal/id.js";
import { OpenClosedProvider as c, State as i, useOpenClosed as u$3 } from "../../internal/open-closed.js";
import { isDisabledReactIssue7711 as r } from "../../utils/bugs.js";
import { Focus as c$1, calculateActiveIndex as f$1 } from "../../utils/calculate-active-index.js";
import { disposables as o$1 } from "../../utils/disposables.js";
import { isFocusableElement as A, FocusableMode as h, focusFrom as j$1, Focus as F, sortByDomNode as _ } from "../../utils/focus-management.js";
import { attemptSubmit as p$1 } from "../../utils/form.js";
import { match as u$1 } from "../../utils/match.js";
import { getOwnerDocument as u$4 } from "../../utils/owner.js";
import { RenderFeatures as M, forwardRefWithAs as W, render as H, useMergeRefsFn as I, mergeProps as D } from "../../utils/render.js";
import { useDescribedBy as G } from "../description/description.js";
import { Keys as o$2 } from "../keyboard.js";
import { useLabels as z, useLabelledBy as I$1, Label as K } from "../label/label.js";
import { Portal as te } from "../portal/portal.js";
var gt = ((o2) => (o2[o2.Open = 0] = "Open", o2[o2.Closed = 1] = "Closed", o2))(gt || {}), Lt = ((o2) => (o2[o2.Single = 0] = "Single", o2[o2.Multi = 1] = "Multi", o2))(Lt || {}), St = ((o2) => (o2[o2.Pointer = 0] = "Pointer", o2[o2.Other = 1] = "Other", o2))(St || {}), Et = ((n2) => (n2[n2.OpenListbox = 0] = "OpenListbox", n2[n2.CloseListbox = 1] = "CloseListbox", n2[n2.GoToOption = 2] = "GoToOption", n2[n2.Search = 3] = "Search", n2[n2.ClearSearch = 4] = "ClearSearch", n2[n2.RegisterOption = 5] = "RegisterOption", n2[n2.UnregisterOption = 6] = "UnregisterOption", n2[n2.SetButtonElement = 7] = "SetButtonElement", n2[n2.SetOptionsElement = 8] = "SetOptionsElement", n2))(Et || {});
function fe(e2, i2 = (o2) => o2) {
  let o2 = e2.activeOptionIndex !== null ? e2.options[e2.activeOptionIndex] : null, r2 = _(i2(e2.options.slice()), (m2) => m2.dataRef.current.domRef.current), a2 = o2 ? r2.indexOf(o2) : null;
  return a2 === -1 && (a2 = null), { options: r2, activeOptionIndex: a2 };
}
let Pt = { [1](e2) {
  return e2.dataRef.current.disabled || e2.listboxState === 1 ? e2 : { ...e2, activeOptionIndex: null, listboxState: 1, __demoMode: false };
}, [0](e2) {
  if (e2.dataRef.current.disabled || e2.listboxState === 0) return e2;
  let i2 = e2.activeOptionIndex, { isSelected: o2 } = e2.dataRef.current, r2 = e2.options.findIndex((a2) => o2(a2.dataRef.current.value));
  return r2 !== -1 && (i2 = r2), { ...e2, listboxState: 0, activeOptionIndex: i2, __demoMode: false };
}, [2](e2, i2) {
  var m2, O, d2, p2, n2;
  if (e2.dataRef.current.disabled || e2.listboxState === 1) return e2;
  let o2 = { ...e2, searchQuery: "", activationTrigger: (m2 = i2.trigger) != null ? m2 : 1, __demoMode: false };
  if (i2.focus === c$1.Nothing) return { ...o2, activeOptionIndex: null };
  if (i2.focus === c$1.Specific) return { ...o2, activeOptionIndex: e2.options.findIndex((u2) => u2.id === i2.id) };
  if (i2.focus === c$1.Previous) {
    let u2 = e2.activeOptionIndex;
    if (u2 !== null) {
      let P = e2.options[u2].dataRef.current.domRef, t = f$1(i2, { resolveItems: () => e2.options, resolveActiveIndex: () => e2.activeOptionIndex, resolveId: (s2) => s2.id, resolveDisabled: (s2) => s2.dataRef.current.disabled });
      if (t !== null) {
        let s2 = e2.options[t].dataRef.current.domRef;
        if (((O = P.current) == null ? void 0 : O.previousElementSibling) === s2.current || ((d2 = s2.current) == null ? void 0 : d2.previousElementSibling) === null) return { ...o2, activeOptionIndex: t };
      }
    }
  } else if (i2.focus === c$1.Next) {
    let u2 = e2.activeOptionIndex;
    if (u2 !== null) {
      let P = e2.options[u2].dataRef.current.domRef, t = f$1(i2, { resolveItems: () => e2.options, resolveActiveIndex: () => e2.activeOptionIndex, resolveId: (s2) => s2.id, resolveDisabled: (s2) => s2.dataRef.current.disabled });
      if (t !== null) {
        let s2 = e2.options[t].dataRef.current.domRef;
        if (((p2 = P.current) == null ? void 0 : p2.nextElementSibling) === s2.current || ((n2 = s2.current) == null ? void 0 : n2.nextElementSibling) === null) return { ...o2, activeOptionIndex: t };
      }
    }
  }
  let r2 = fe(e2), a2 = f$1(i2, { resolveItems: () => r2.options, resolveActiveIndex: () => r2.activeOptionIndex, resolveId: (u2) => u2.id, resolveDisabled: (u2) => u2.dataRef.current.disabled });
  return { ...o2, ...r2, activeOptionIndex: a2 };
}, [3]: (e2, i2) => {
  if (e2.dataRef.current.disabled || e2.listboxState === 1) return e2;
  let r2 = e2.searchQuery !== "" ? 0 : 1, a2 = e2.searchQuery + i2.value.toLowerCase(), O = (e2.activeOptionIndex !== null ? e2.options.slice(e2.activeOptionIndex + r2).concat(e2.options.slice(0, e2.activeOptionIndex + r2)) : e2.options).find((p2) => {
    var n2;
    return !p2.dataRef.current.disabled && ((n2 = p2.dataRef.current.textValue) == null ? void 0 : n2.startsWith(a2));
  }), d2 = O ? e2.options.indexOf(O) : -1;
  return d2 === -1 || d2 === e2.activeOptionIndex ? { ...e2, searchQuery: a2 } : { ...e2, searchQuery: a2, activeOptionIndex: d2, activationTrigger: 1 };
}, [4](e2) {
  return e2.dataRef.current.disabled || e2.listboxState === 1 || e2.searchQuery === "" ? e2 : { ...e2, searchQuery: "" };
}, [5]: (e2, i2) => {
  let o2 = { id: i2.id, dataRef: i2.dataRef }, r2 = fe(e2, (a2) => [...a2, o2]);
  return e2.activeOptionIndex === null && e2.dataRef.current.isSelected(i2.dataRef.current.value) && (r2.activeOptionIndex = r2.options.indexOf(o2)), { ...e2, ...r2 };
}, [6]: (e2, i2) => {
  let o2 = fe(e2, (r2) => {
    let a2 = r2.findIndex((m2) => m2.id === i2.id);
    return a2 !== -1 && r2.splice(a2, 1), r2;
  });
  return { ...e2, ...o2, activationTrigger: 1 };
}, [7]: (e2, i2) => e2.buttonElement === i2.element ? e2 : { ...e2, buttonElement: i2.element }, [8]: (e2, i2) => e2.optionsElement === i2.element ? e2 : { ...e2, optionsElement: i2.element } }, be = createContext(null);
be.displayName = "ListboxActionsContext";
function Z(e2) {
  let i2 = useContext(be);
  if (i2 === null) {
    let o2 = new Error(`<${e2} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o2, Z), o2;
  }
  return i2;
}
let ee = createContext(null);
ee.displayName = "ListboxDataContext";
function Q(e2) {
  let i2 = useContext(ee);
  if (i2 === null) {
    let o2 = new Error(`<${e2} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o2, Q), o2;
  }
  return i2;
}
function At(e2, i2) {
  return u$1(i2.type, Pt, e2, i2);
}
let Rt = Fragment;
function ht(e2, i$1) {
  var Te;
  let o$12 = a(), { value: r2, defaultValue: a$1, form: m2, name: O, onChange: d2, by: p$12, invalid: n$12 = false, disabled: u$22 = o$12 || false, horizontal: P = false, multiple: t = false, __demoMode: s2 = false, ...M2 } = e2;
  const B = P ? "horizontal" : "vertical";
  let h$1 = y(i$1), D2 = l(a$1), [g = t ? [] : void 0, y$12] = T(r2, d2, D2), [_2, x] = useReducer(At, { dataRef: createRef(), listboxState: s2 ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: false, buttonElement: null, optionsElement: null, __demoMode: s2 }), k = useRef({ static: false, hold: false }), F2 = useRef(/* @__PURE__ */ new Map()), c$2 = u(p$12), A$1 = useCallback((b) => u$1(f2.mode, { [1]: () => g.some((S) => c$2(S, b)), [0]: () => c$2(g, b) }), [g]), f2 = useMemo(() => ({ ..._2, value: g, disabled: u$22, invalid: n$12, mode: t ? 1 : 0, orientation: B, compare: c$2, isSelected: A$1, optionsPropsRef: k, listRef: F2 }), [g, u$22, n$12, t, _2, F2]);
  n(() => {
    _2.dataRef.current = f2;
  }, [f2]);
  let N = f2.listboxState === 0;
  R(N, [f2.buttonElement, f2.optionsElement], (b, S) => {
    var C;
    x({ type: 1 }), A(S, h.Loose) || (b.preventDefault(), (C = f2.buttonElement) == null || C.focus());
  });
  let L = useMemo(() => ({ open: f2.listboxState === 0, disabled: u$22, invalid: n$12, value: g }), [f2, u$22, g, n$12]), H$12 = o((b) => {
    let S = f2.options.find((C) => C.id === b);
    S && K2(S.dataRef.current.value);
  }), te2 = o(() => {
    if (f2.activeOptionIndex !== null) {
      let { dataRef: b, id: S } = f2.options[f2.activeOptionIndex];
      K2(b.current.value), x({ type: 2, focus: c$1.Specific, id: S });
    }
  }), oe = o(() => x({ type: 0 })), X = o(() => x({ type: 1 })), J = p(), ne = o((b, S, C) => {
    J.dispose(), J.microTask(() => b === c$1.Specific ? x({ type: 2, focus: c$1.Specific, id: S, trigger: C }) : x({ type: 2, focus: b, trigger: C }));
  }), ie = o((b, S) => (x({ type: 5, id: b, dataRef: S }), () => x({ type: 6, id: b }))), K2 = o((b) => u$1(f2.mode, { [0]() {
    return y$12 == null ? void 0 : y$12(b);
  }, [1]() {
    let S = f2.value.slice(), C = S.findIndex((Pe) => c$2(Pe, b));
    return C === -1 ? S.push(b) : S.splice(C, 1), y$12 == null ? void 0 : y$12(S);
  } })), $ = o((b) => x({ type: 3, value: b })), q = o(() => x({ type: 4 })), l$12 = o((b) => {
    x({ type: 7, element: b });
  }), I2 = o((b) => {
    x({ type: 8, element: b });
  }), G2 = useMemo(() => ({ onChange: K2, registerOption: ie, goToOption: ne, closeListbox: X, openListbox: oe, selectActiveOption: te2, selectOption: H$12, search: $, clearSearch: q, setButtonElement: l$12, setOptionsElement: I2 }), []), [re, Le] = z({ inherit: true }), Se = { ref: h$1 }, Ee = useCallback(() => {
    if (D2 !== void 0) return y$12 == null ? void 0 : y$12(D2);
  }, [y$12, D2]);
  return React__default.createElement(Le, { value: re, props: { htmlFor: (Te = f2.buttonElement) == null ? void 0 : Te.id }, slot: { open: f2.listboxState === 0, disabled: u$22 } }, React__default.createElement(ve, null, React__default.createElement(be.Provider, { value: G2 }, React__default.createElement(ee.Provider, { value: f2 }, React__default.createElement(c, { value: u$1(f2.listboxState, { [0]: i.Open, [1]: i.Closed }) }, O != null && g != null && React__default.createElement(j, { disabled: u$22, data: { [O]: g }, form: m2, onReset: Ee }), H({ ourProps: Se, theirProps: M2, slot: L, defaultTag: Rt, name: "Listbox" }))))));
}
let Dt = "button";
function _t(e$1, i2) {
  var N;
  let o$12 = Q("Listbox.Button"), r$1 = Z("Listbox.Button"), a2 = useId(), m2 = u$2(), { id: O = m2 || `headlessui-listbox-button-${a2}`, disabled: d2 = o$12.disabled || false, autoFocus: p2 = false, ...n2 } = e$1, u2 = I(), P = y(i2, ye(), r$1.setButtonElement), t = Fe(), s2 = o((L) => {
    switch (L.key) {
      case o$2.Enter:
        p$1(L.currentTarget);
        break;
      case o$2.Space:
      case o$2.ArrowDown:
        L.preventDefault(), flushSync(() => r$1.openListbox()), o$12.value || r$1.goToOption(c$1.First);
        break;
      case o$2.ArrowUp:
        L.preventDefault(), flushSync(() => r$1.openListbox()), o$12.value || r$1.goToOption(c$1.Last);
        break;
    }
  }), M2 = o((L) => {
    switch (L.key) {
      case o$2.Space:
        L.preventDefault();
        break;
    }
  }), B = o((L) => {
    var H2;
    if (r(L.currentTarget)) return L.preventDefault();
    o$12.listboxState === 0 ? (flushSync(() => r$1.closeListbox()), (H2 = o$12.buttonElement) == null || H2.focus({ preventScroll: true })) : (L.preventDefault(), r$1.openListbox());
  }), h2 = o((L) => L.preventDefault()), D$1 = I$1([O]), g = G(), { isFocusVisible: y$12, focusProps: _2 } = $f7dceffc5ad7768b$export$4e328f61c538687f({ autoFocus: p2 }), { isHovered: x, hoverProps: k } = $6179b936705e76d3$export$ae780daf29e6d456({ isDisabled: d2 }), { pressed: F2, pressProps: c2 } = w({ disabled: d2 }), A2 = useMemo(() => ({ open: o$12.listboxState === 0, active: F2 || o$12.listboxState === 0, disabled: d2, invalid: o$12.invalid, value: o$12.value, hover: x, focus: y$12, autofocus: p2 }), [o$12.listboxState, o$12.value, d2, x, y$12, F2, o$12.invalid, p2]), f2 = D(t(), { ref: P, id: O, type: e(e$1, o$12.buttonElement), "aria-haspopup": "listbox", "aria-controls": (N = o$12.optionsElement) == null ? void 0 : N.id, "aria-expanded": o$12.listboxState === 0, "aria-labelledby": D$1, "aria-describedby": g, disabled: d2 || void 0, autoFocus: p2, onKeyDown: s2, onKeyUp: M2, onKeyPress: h2, onClick: B }, _2, k, c2);
  return H({ mergeRefs: u2, ourProps: f2, theirProps: n2, slot: A2, defaultTag: Dt, name: "Listbox.Button" });
}
let ge = createContext(false), It = "div", Ct = M.RenderStrategy | M.Static;
function Ft(e2, i$1) {
  var $, q;
  let o$12 = useId(), { id: r2 = `headlessui-listbox-options-${o$12}`, anchor: a2, portal: m$1 = false, modal: O = true, transition: d$1 = false, ...p$12 } = e2, n2 = xe(a2), [u2, P] = useState(null);
  n2 && (m$1 = true);
  let t = Q("Listbox.Options"), s$12 = Z("Listbox.Options"), M2 = n$1(t.optionsElement), B = u$3(), [h2, D$1] = R$1(d$1, u2, B !== null ? (B & i.Open) === i.Open : t.listboxState === 0);
  m(h2, t.buttonElement, s$12.closeListbox);
  let g = t.__demoMode ? false : O && t.listboxState === 0;
  f(g, M2);
  let y$2 = t.__demoMode ? false : O && t.listboxState === 0;
  y$1(y$2, { allowed: useCallback(() => [t.buttonElement, t.optionsElement], [t.buttonElement, t.optionsElement]) });
  let _2 = t.listboxState !== 0, k = s(_2, t.buttonElement) ? false : h2, F$1 = h2 && t.listboxState === 1, c2 = l$1(F$1, t.value), A2 = o((l2) => t.compare(c2, l2)), f$12 = useMemo(() => {
    var I2;
    if (n2 == null || !((I2 = n2 == null ? void 0 : n2.to) != null && I2.includes("selection"))) return null;
    let l2 = t.options.findIndex((G2) => A2(G2.dataRef.current.value));
    return l2 === -1 && (l2 = 0), l2;
  }, [n2, t.options]), N = (() => {
    if (n2 == null) return;
    if (f$12 === null) return { ...n2, inner: void 0 };
    let l2 = Array.from(t.listRef.current.values());
    return { ...n2, inner: { listRef: { current: l2 }, index: f$12 } };
  })(), [L, H$2] = Re(N), te$1 = be$1(), oe = y(i$1, n2 ? L : null, s$12.setOptionsElement, P), X = p();
  useEffect(() => {
    var I2;
    let l2 = t.optionsElement;
    l2 && t.listboxState === 0 && l2 !== ((I2 = u$4(l2)) == null ? void 0 : I2.activeElement) && (l2 == null || l2.focus({ preventScroll: true }));
  }, [t.listboxState, t.optionsElement]);
  let J = o((l2) => {
    var I2, G2;
    switch (X.dispose(), l2.key) {
      case o$2.Space:
        if (t.searchQuery !== "") return l2.preventDefault(), l2.stopPropagation(), s$12.search(l2.key);
      case o$2.Enter:
        if (l2.preventDefault(), l2.stopPropagation(), t.activeOptionIndex !== null) {
          let { dataRef: re } = t.options[t.activeOptionIndex];
          s$12.onChange(re.current.value);
        }
        t.mode === 0 && (flushSync(() => s$12.closeListbox()), (I2 = t.buttonElement) == null || I2.focus({ preventScroll: true }));
        break;
      case u$1(t.orientation, { vertical: o$2.ArrowDown, horizontal: o$2.ArrowRight }):
        return l2.preventDefault(), l2.stopPropagation(), s$12.goToOption(c$1.Next);
      case u$1(t.orientation, { vertical: o$2.ArrowUp, horizontal: o$2.ArrowLeft }):
        return l2.preventDefault(), l2.stopPropagation(), s$12.goToOption(c$1.Previous);
      case o$2.Home:
      case o$2.PageUp:
        return l2.preventDefault(), l2.stopPropagation(), s$12.goToOption(c$1.First);
      case o$2.End:
      case o$2.PageDown:
        return l2.preventDefault(), l2.stopPropagation(), s$12.goToOption(c$1.Last);
      case o$2.Escape:
        l2.preventDefault(), l2.stopPropagation(), flushSync(() => s$12.closeListbox()), (G2 = t.buttonElement) == null || G2.focus({ preventScroll: true });
        return;
      case o$2.Tab:
        l2.preventDefault(), l2.stopPropagation(), flushSync(() => s$12.closeListbox()), j$1(t.buttonElement, l2.shiftKey ? F.Previous : F.Next);
        break;
      default:
        l2.key.length === 1 && (s$12.search(l2.key), X.setTimeout(() => s$12.clearSearch(), 350));
        break;
    }
  }), ne = ($ = t.buttonElement) == null ? void 0 : $.id, ie = useMemo(() => ({ open: t.listboxState === 0 }), [t.listboxState]), K2 = D(n2 ? te$1() : {}, { id: r2, ref: oe, "aria-activedescendant": t.activeOptionIndex === null || (q = t.options[t.activeOptionIndex]) == null ? void 0 : q.id, "aria-multiselectable": t.mode === 1 ? true : void 0, "aria-labelledby": ne, "aria-orientation": t.orientation, onKeyDown: J, role: "listbox", tabIndex: t.listboxState === 0 ? 0 : void 0, style: { ...p$12.style, ...H$2, "--button-width": d(t.buttonElement, true).width }, ...H$1(D$1) });
  return React__default.createElement(te, { enabled: m$1 ? e2.static || h2 : false }, React__default.createElement(ee.Provider, { value: t.mode === 1 ? t : { ...t, isSelected: A2 } }, H({ ourProps: K2, theirProps: p$12, slot: ie, defaultTag: It, features: Ct, visible: k, name: "Listbox.Options" })));
}
let Mt = "div";
function Bt(e2, i2) {
  let o$22 = useId(), { id: r2 = `headlessui-listbox-option-${o$22}`, disabled: a2 = false, value: m2, ...O } = e2, d2 = useContext(ge) === true, p2 = Q("Listbox.Option"), n$12 = Z("Listbox.Option"), u2 = p2.activeOptionIndex !== null ? p2.options[p2.activeOptionIndex].id === r2 : false, P = p2.isSelected(m2), t = useRef(null), s2 = s$1(t), M2 = s$2({ disabled: a2, value: m2, domRef: t, get textValue() {
    return s2();
  } }), B = y(i2, t, (c2) => {
    c2 ? p2.listRef.current.set(r2, c2) : p2.listRef.current.delete(r2);
  });
  n(() => {
    if (!p2.__demoMode && p2.listboxState === 0 && u2 && p2.activationTrigger !== 0) return o$1().requestAnimationFrame(() => {
      var c2, A2;
      (A2 = (c2 = t.current) == null ? void 0 : c2.scrollIntoView) == null || A2.call(c2, { block: "nearest" });
    });
  }, [t, u2, p2.__demoMode, p2.listboxState, p2.activationTrigger, p2.activeOptionIndex]), n(() => {
    if (!d2) return n$12.registerOption(r2, M2);
  }, [M2, r2, d2]);
  let h2 = o((c2) => {
    var A2;
    if (a2) return c2.preventDefault();
    n$12.onChange(m2), p2.mode === 0 && (flushSync(() => n$12.closeListbox()), (A2 = p2.buttonElement) == null || A2.focus({ preventScroll: true }));
  }), D2 = o(() => {
    if (a2) return n$12.goToOption(c$1.Nothing);
    n$12.goToOption(c$1.Specific, r2);
  }), g = u$5(), y$12 = o((c2) => {
    g.update(c2), !a2 && (u2 || n$12.goToOption(c$1.Specific, r2, 0));
  }), _2 = o((c2) => {
    g.wasMoved(c2) && (a2 || u2 || n$12.goToOption(c$1.Specific, r2, 0));
  }), x = o((c2) => {
    g.wasMoved(c2) && (a2 || u2 && n$12.goToOption(c$1.Nothing));
  }), k = useMemo(() => ({ active: u2, focus: u2, selected: P, disabled: a2, selectedOption: P && d2 }), [u2, P, a2, d2]), F2 = d2 ? {} : { id: r2, ref: B, role: "option", tabIndex: a2 === true ? void 0 : -1, "aria-disabled": a2 === true ? true : void 0, "aria-selected": P, disabled: void 0, onClick: h2, onFocus: D2, onPointerEnter: y$12, onMouseEnter: y$12, onPointerMove: _2, onMouseMove: _2, onPointerLeave: x, onMouseLeave: x };
  return !P && d2 ? null : H({ ourProps: F2, theirProps: O, slot: k, defaultTag: Mt, name: "Listbox.Option" });
}
let wt = Fragment;
function kt(e2, i2) {
  let { options: o2, placeholder: r2, ...a2 } = e2, O = { ref: y(i2) }, d2 = Q("ListboxSelectedOption"), p2 = useMemo(() => ({}), []), n2 = d2.value === void 0 || d2.value === null || d2.mode === 1 && Array.isArray(d2.value) && d2.value.length === 0;
  return React__default.createElement(ge.Provider, { value: true }, H({ ourProps: O, theirProps: { ...a2, children: React__default.createElement(React__default.Fragment, null, r2 && n2 ? r2 : o2) }, slot: p2, defaultTag: wt, name: "ListboxSelectedOption" }));
}
let Ut = W(ht), Nt = W(_t), Ht = K, Gt = W(Ft), Vt = W(Bt), Kt = W(kt), Mo = Object.assign(Ut, { Button: Nt, Label: Ht, Options: Gt, Option: Vt, SelectedOption: Kt });
export {
  Mo as Listbox,
  Nt as ListboxButton,
  Ht as ListboxLabel,
  Vt as ListboxOption,
  Gt as ListboxOptions,
  Kt as ListboxSelectedOption
};
